import { getPosts } from './_utils/getPosts';
import { getAllTags } from './_utils/tags';

export const prerender = true;

export const load = async () => {
	const posts = getPosts();
	const tags = getAllTags(posts);
	return { posts, tags };
};
